import React from 'react'
import MainBanner from '../../components/MainComponents/MainBanner'
import { bannerServiceImage, contactusBanner,contactBanners, mainTitle } from '../../config'
import ContactSection from '../../components/ContactComponents/ContactSection'
import Footer from '../../components/MainComponents/Footer'
import AreasWeServe from '../../components/MainComponents/AreasWeServe'
import MapSection from '../../components/ContactComponents/MapSection'
import ContactHeader from '../../components/MainComponents/ContactHeader'

const ContactUsPage = () => {
  return (
    <div>
      <ContactHeader/>
         <MainBanner
        
         bannerTitle={mainTitle}
         banenrHeadline={"Connect with Us Today"}
         showContactButton = {false}
         mainBannerImages = {[contactBanners.bannerOne,contactBanners.bannerTwo,contactBanners.bannerThree]}
         bannerDescription={"We're here to help with your physiotherapy needs. Reach out to us for any questions, appointments, or support on your journey to recovery"}
        />
        <ContactSection/>
        <MapSection/>
        <Footer/>
    </div>
  )
}

export default ContactUsPage